import { Component, Input } from '@angular/core';

import { LineUsage } from 'store/usage/models';
import { LineSummary } from 'store/account-summary/models';

import { ActivityOptions } from 'my-account/constants';

@Component({
    selector: 'usage-history',
    styleUrls: ['./past-usage.scss'],
    templateUrl: './past-usage.html',
    standalone: false
})

export class PastUsageComponent {
    @Input() public usages: LineUsage[];
    @Input() public currentLine: LineSummary;
    @Input() public showCallAndText: boolean;
    @Input() public pageData: CmsUsageHistoryPageData;

    // Call and Message Log Activities
    public call: string = ActivityOptions.CALLS;
    public messages: string = ActivityOptions.MESSAGES;

    public displayUsageLink(usageLogNumber: number): boolean {
        return usageLogNumber > 0;
    }
}
